import _Object$assign from 'babel-runtime/core-js/object/assign';

import ImagePreviewer from '@/components/ImagePreviewer/index.vue';
import TableList from '@/components/TableList/index.vue';
import ActionColumn from './action-column.vue';

export default {
  components: {
    ImagePreviewer: ImagePreviewer,
    TableList: TableList,
    ActionColumn: ActionColumn
  },

  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      tableConfig: {},

      tableColumnConfig: [{
        label: 'ID',
        prop: 'id',
        width: 70
      }, {
        label: '图标',
        prop: 'app_icon',
        width: 80,
        type: 'image', // 类型
        params: {
          width: 50,
          preview: true
        }
      }, {
        label: '名称',
        prop: 'app_name',
        width: 200,
        type: 'link',
        params: {
          link: function link(_ref) {
            var row = _ref.row;

            return row.app_url;
          }
        }
      }, {
        label: '平台',
        prop: 'platform'
      }, {
        label: '缩略图',
        prop: 'thumbnail',
        width: 200,
        type: 'image', // 类型
        params: {
          width: 180,
          preview: true,
          popoverWidth: 500
        }
      }, {
        label: '包名',
        prop: 'package_name',
        width: 200
      }, {
        label: '来源',
        prop: 'network'
      }, {
        label: '类别',
        prop: 'category'
      }, {
        label: '采集时间',
        prop: 'grab_time',
        type: 'time'
      }, {
        label: '素材类型',
        prop: 'material_category'
      },
      // 动态组件
      {
        component: ActionColumn,
        label: '操作',
        prop: 'action',
        width: 100,
        fixed: 'right'
      }]
    };
  },


  computed: {
    innerList: function innerList() {
      var _this = this;

      return this.list.map(function (item) {
        return _Object$assign({}, item, {
          material_category: _this.convertMaterialCategory(item.is_playable)
        });
      });
    }
  },

  methods: {
    convertMaterialCategory: function convertMaterialCategory(val) {
      var map = ['Playable', '非 Playable', 'Unknown'];
      return map[Number(val) - 1];
    }
  }
};